import superagent from 'superagent';

export function lssLogin (vin, accountNo, cb) {
	superagent
		.post(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/self-schedule/lessee/log-in`, { vin, accountNo })
		.end(cb);
}

export function getReasons (token, cb) {
	superagent
		.get(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/status-reasons`)
		.set('Authorization', `Bearer ${token}`)
		.end(cb);
}

export function getRequest (requestId, token, cb) {
	superagent
		.get(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/${requestId}`)
		.set('Authorization', `Bearer ${token}`)
		.end(cb);
}

export function getPhotos (vehicleId, token, cb) {
	superagent
		.get(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/vehicle/${vehicleId}/photos`)
		.set('Authorization', `Bearer ${token}`)
		.end(cb);
}

export function addComment (requestId, comment, token, cb) {
	superagent
		.post(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/${requestId}/comment`)
		.set('Authorization', `Bearer ${token}`)
		.send({ commentText: comment })
		.end(cb);
}

export function getAvailability (params, token, cb) {
	superagent
		.get(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/appointment/availability`)
		.query(params)
		.set('Authorization', `Bearer ${token}`)
		.end(cb);
}

export function postAuthCode (authCode, cb) {
	superagent
		.post(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/self-schedule/sso/auth-code`, { authCode })
		.end(cb);
}

export function updateRequest (requestId, updates, token, cb) {
	superagent
		.post(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v2/inspection-request/${requestId}`)
		.set('Authorization', `Bearer ${token}`)
		.send(updates)
		.end(cb);
}

export function updateStatus (requestId, status, reasonId, token, cb) {
	superagent
		.post(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/${requestId}/status`)
		.set('Authorization', `Bearer ${token}`)
		.send({ status, reasonId })
		.end(cb);
}

export function scheduleAppointment (requestId, appt, token, cb) {
	superagent
		.post(`${import.meta.env.VITE_REQUEST_PROCESSOR_URL}/api/v1/inspection-request/${requestId}/appointment`)
		.set('Authorization', `Bearer ${token}`)
		.send(appt)
		.end(cb);
}
